import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pager',
  standalone: true,
  template: `
    @if (totalPages > 0) {
      <ul class="pagination pull-right">
        @if (totalPages > 11) {
          <li class="page-item" [class.disabled]="pageIndex === 0">
            <a class="page-link" href="" aria-label="Previous" (click)="$event.preventDefault(); go(0)">
              <span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span>
            </a>
          </li>
          <li class="page-item" [class.disabled]="pageIndex === 0">
            <a class="page-link" href="" aria-label="Previous" (click)="$event.preventDefault(); go(pageIndex - 1)">
              <span aria-hidden="true">prev</span><span class="sr-only">Previous</span>
            </a>
          </li>
        }
        @for (p of visiblePages; track p) {
          <li class="page-item" [class.active]="p === pageIndex">
            <a class="page-link" href="" (click)="$event.preventDefault(); go(p)">{{ p + 1 }}</a>
          </li>
        }
        @if (totalPages > 11) {
          <li class="page-item" [class.disabled]="pageIndex >= totalPages - 1">
            <a class="page-link" href="" aria-label="Next" (click)="$event.preventDefault(); go(pageIndex + 1)">
              <span aria-hidden="true">next</span><span class="sr-only">Next</span>
            </a>
          </li>
          <li class="page-item" [class.disabled]="pageIndex >= totalPages - 1">
            <a class="page-link" href="" aria-label="Next" (click)="$event.preventDefault(); go(totalPages - 1)">
              <span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span>
            </a>
          </li>
        }
      </ul>
    }
  `,
})
export class PagerComponent {
  @Input() pageIndex = 0;
  @Input() totalPages = 0;
  @Output() pageChange = new EventEmitter<number>();

  get visiblePages(): number[] {
    if (this.totalPages <= 0) return [];
    const w = 11;
    let start = Math.max(0, this.pageIndex - Math.floor(w / 2));
    let end = start + w;
    if (end > this.totalPages) {
      end = this.totalPages;
      start = Math.max(0, end - w);
    }
    return Array.from({ length: end - start }, (_, i) => start + i);
  }

  go(n: number): void {
    if (n >= 0 && n < this.totalPages) {
      this.pageChange.emit(n);
    }
  }
}
